/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountAllocation,
  CashAllocationPage,
  Filter,
  GrowthAllocationPage,
  HTTPValidationError,
  SecuredAllocationPage,
} from '../models/index';
import {
    AccountAllocationFromJSON,
    AccountAllocationToJSON,
    CashAllocationPageFromJSON,
    CashAllocationPageToJSON,
    FilterFromJSON,
    FilterToJSON,
    GrowthAllocationPageFromJSON,
    GrowthAllocationPageToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    SecuredAllocationPageFromJSON,
    SecuredAllocationPageToJSON,
} from '../models/index';

export interface GetAccountAllocationRequest {
    accountGuid: string;
    debug?: boolean;
}

export interface GetCashAllocationRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface GetPreTradeGrowthAllocationRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface GetSecuredAllocationRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

/**
 * 
 */
export class AllocationApi extends runtime.BaseAPI {

    /**
     * Get Account Allocation
     */
    async getAccountAllocationRaw(requestParameters: GetAccountAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountAllocation>> {
        if (requestParameters.accountGuid === null || requestParameters.accountGuid === undefined) {
            throw new runtime.RequiredError('accountGuid','Required parameter requestParameters.accountGuid was null or undefined when calling getAccountAllocation.');
        }

        const queryParameters: any = {};

        if (requestParameters.debug !== undefined) {
            queryParameters['debug'] = requestParameters.debug;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/account/{account_guid}/allocation`.replace(`{${"account_guid"}}`, encodeURIComponent(String(requestParameters.accountGuid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountAllocationFromJSON(jsonValue));
    }

    /**
     * Get Account Allocation
     */
    async getAccountAllocation(requestParameters: GetAccountAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountAllocation> {
        const response = await this.getAccountAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve Cash allocation report from the Rebalance DB with the specified filters.
     */
    async getCashAllocationRaw(requestParameters: GetCashAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CashAllocationPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/cash-allocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CashAllocationPageFromJSON(jsonValue));
    }

    /**
     * Retrieve Cash allocation report from the Rebalance DB with the specified filters.
     */
    async getCashAllocation(requestParameters: GetCashAllocationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CashAllocationPage> {
        const response = await this.getCashAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve pre-trade Growth allocation report from the Rebalance DB with the specified filters.
     */
    async getPreTradeGrowthAllocationRaw(requestParameters: GetPreTradeGrowthAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GrowthAllocationPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/pre-trade-growth-allocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GrowthAllocationPageFromJSON(jsonValue));
    }

    /**
     * Retrieve pre-trade Growth allocation report from the Rebalance DB with the specified filters.
     */
    async getPreTradeGrowthAllocation(requestParameters: GetPreTradeGrowthAllocationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GrowthAllocationPage> {
        const response = await this.getPreTradeGrowthAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve Secured allocation report from the Rebalance DB with the specified filters.
     */
    async getSecuredAllocationRaw(requestParameters: GetSecuredAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecuredAllocationPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/secured-allocation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecuredAllocationPageFromJSON(jsonValue));
    }

    /**
     * Retrieve Secured allocation report from the Rebalance DB with the specified filters.
     */
    async getSecuredAllocation(requestParameters: GetSecuredAllocationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecuredAllocationPage> {
        const response = await this.getSecuredAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
